import React, { useState, useEffect, useRef } from "react"
import OutsideClickTrigger from "../common/OutsideClickTrigger"
import config from "react-global-configuration"
import { parkingState } from "../../zustand/parkingState"

const ParkingShowMapModal = (props) => {
  const [mobileActive, setMobileActive] = useState(false)

  useEffect(() => {
    // new PanningMap({ el: this.refs.panningMapContainer })
    // new ParkingLotPicker({ el: this.refs.parkingLotPickerContainer })
  }, [])

  const activateMobileMap = (e) => {
    setMobileActive(true)
  }

  const getClass = (type) => {
    if (type.startsWith("We Park You Fly")) return "weparkyoufly"
    switch (type) {
      case "Budget":
        return "budget"
      case "Direct":
        return "direct"
      case "Standard":
        return "standard"
      case "Standard+":
        return "standard-plus"
      default:
        return ""
    }
  }

  const textKeys = config.get("textKeys.parkingList.mapModal") || {}
  const textKeysClose = config.get("textKeys.mainApp")
  const key = props.item.name === "We park you fly" ? props.item.name : props.item.carPark.name
  const conf = config.get("content")
  const longitude = conf.carParks[key].geoLocation.x
  const latitude = conf.carParks[key].geoLocation.y

  const closeButtonRef = useRef(null)

  useEffect(() => {
    if (closeButtonRef) closeButtonRef?.current?.focus() || null
  }, [closeButtonRef])

  const handleCloseButton = () => {
    const returnToNode = document.getElementById(parkingState.getState().modalOpenerId)
    if (returnToNode) returnToNode.focus()
    parkingState.setState({ isParkingProductMapModalActive: false })
  }
  return (
    <div className={!mobileActive ? "overlay overlay--modal overlay--fixed is-active" : ""}>
      <div className={!mobileActive ? "modal modal--iframe-modal" : ""}>
        <OutsideClickTrigger onOutsideClick={() => parkingState.setState({ isParkingProductMapModalActive: false })}>
          <React.Fragment>
            <button
              ref={closeButtonRef}
              aria-label={`${textKeysClose?.modalCloseAriaLabel}`}
              className="button button--icon modal-close close-map"
              onClick={() => handleCloseButton()}
            >
              <span className="icon">
                <svg className="svg-icon svg-icon--close-new">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                    &nbsp;
                  </use>
                </svg>
              </span>
            </button>
            <div className="modal__content modal__content--no-padding">
              <div className="modal__content__inner">
                <div className="modal__middle" style={{ padding: "0px", margin: "0px" }}>
                  <div className="modal__middle__inner">
                    <iframe
                      title="Google Maps Modal"
                      id="gmap_canvas"
                      src={`https://maps.google.com/maps?q=${latitude},${longitude}&output=embed`}
                      width="100%"
                      height="500"
                      frameBorder={0}
                      scrolling="no"
                      marginHeight={0}
                      marginWidth={0}
                    />
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        </OutsideClickTrigger>
      </div>
    </div>
  )
}

export default ParkingShowMapModal
